import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import english from "./en/translation.json";
import hebrew from "./he/translation.json";

const resources = {
  en: {
    translation: english,
  },
  he: {
    translation: hebrew,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "he",
  //   fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
